import { AuthState } from "../../types";
import {
  LOGIN_USER_FAILURE,
  LOGIN_USER_SUCCESS,
  LOGOUT_USER_REQUEST,
  REGISTER_USER_SUCCESS,
  EMAIL_VERIFIED_SUCCESS,
  UPDATE_LOGIN_USER,
} from "../constants";

const initialState: AuthState = {
  currentUser: undefined,
  emailVerified: false,
  phoneVerified: false,
  authType: "email",
};

// eslint-disable-next-line
export default (state = initialState, action: any): any => {
  switch (action.type) {
    case LOGIN_USER_SUCCESS:
      return {
        ...state,
        currentUser: action.payload.user,
        emailVerified: action.payload.emailVerified,
        authType: action.payload.authType,
      };
    case LOGIN_USER_FAILURE:
      return {
        ...state,
        currentUser: null,
        emailVerified: false,
        authType: "email",
      };
    case REGISTER_USER_SUCCESS:
      return {
        ...state,
        currentUser: action.payload.user,
        emailVerified: false,
        authType: "email",
      };
    case LOGOUT_USER_REQUEST:
      return {
        ...state,
        currentUser: undefined,
        emailVerified: false,
        authType: "email",
      };
    case EMAIL_VERIFIED_SUCCESS:
      return {
        ...state,
        emailVerified: true,
      };
    case UPDATE_LOGIN_USER:
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          ...action.payload.userInfo,
        },
      };
    default:
      return state;
  }
};
